import { Fragment } from 'react';

const LeagueList = ({ context }) => {
  return (
    <div className='col-12 my-3'>
      <div className='d-flex flex-row justify-content-between align-items-center my-3'>
        <div className='d-flex flex-row align-items-center'>
          <i className='far fa-sitemap f-18 text-dark'></i>
          <span className='text-dark f-14 font-weight-bold mx-2'>
            لیست تیم های لیگ
          </span>{' '}
        </div>
      </div>

      <>
        {context?.leagues?.length > 0 ? (
          <>
            {context?.leagues?.map((league) => (
              <Fragment key={league?.id}>
                <div className='d-flex flex-row justify-content-between align-items-center border-bottom border-dark pb-3'>
                  <div className='d-flex flex-row align-items-center mt-1'>
                    <span className='text-dark f-14 font-weight-bold'>
                      نام تیم :{' '}
                    </span>
                    <span className='text-dark f-14 font-weight-bold mx-2'>
                      {league?.name}
                    </span>
                  </div>
                </div>
                {league?.users?.length > 0 ? (
                  <table className='table table-striped my-3 text-left'>
                    <thead>
                      <tr className='bg-purple text-white'>
                        <th scope='col'>#</th>
                        <th scope='col'></th>
                        <th scope='col'>کد ملی</th>
                        <th scope='col'>استان محل زندگی</th>
                        <th scope='col'>زورخانه</th>
                        <th scope='col'>رشته</th>
                        <th scope='col'>وزن</th>
                        <th scope='col'>رده سنی</th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {league.users?.map((user, index) => (
                          <tr key={user?.id}>
                            <th scope='row'>{index + 1}</th>
                            <td>
                              {user?.name} {user?.last_name}
                            </td>
                            <td>{user?.national_card_id}</td>
                            <td>{user?.province_living?.name}</td>
                            <td>{user?.gym?.name}</td>
                            <td>
                              {user?.sport_id?.map((s) => s?.title + ',')}
                            </td>
                            <td>
                              {
                                context.competition?.weights?.find(
                                  (s) => s?.id == user?.weight_id,
                                )?.weight
                              }
                            </td>
                            <td>
                              {
                                context.competition?.ages?.find(
                                  (s) => s?.id == user?.age_id,
                                )?.title
                              }
                            </td>
                          </tr>
                        ))}
                      </>
                    </tbody>
                  </table>
                ) : (
                  <div className='d-flex flex-row justify-content-center align-items-center my-3'>
                    اطلاعاتی جهت نمایش یافت نشد.
                  </div>
                )}
              </Fragment>
            ))}
          </>
        ) : (
          <div className='d-flex flex-row justify-content-center align-items-center my-3'>
            اطلاعاتی جهت نمایش یافت نشد.
          </div>
        )}
      </>
    </div>
  );
};

export default LeagueList;
